export const environment = {
    production: true,
    _env_api: 'https://ics-shop-api.azurewebsites.net',
    env_api: 'https://shop-ie-api-prod-gmdqfahfavfadxd8.northeurope-01.azurewebsites.net',
    stripe_key: 'pk_test_bKoEJzXJUAawQ3PNi3ZMCEcb',
    stripe_process_api: 'https://zendcode.herokuapp.com/stripecheckout/shop-stripe'
};
